import { render, staticRenderFns } from "./NotificationBell.vue?vue&type=template&id=717c9484"
import script from "./NotificationBell.vue?vue&type=script&lang=js"
export * from "./NotificationBell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tomi/Projects/ingeniAR/rrhh/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('717c9484')) {
      api.createRecord('717c9484', component.options)
    } else {
      api.reload('717c9484', component.options)
    }
    module.hot.accept("./NotificationBell.vue?vue&type=template&id=717c9484", function () {
      api.rerender('717c9484', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/NotificationBell.vue"
export default component.exports